<!-- @format -->
<section
	[id]="'accordion' + tagSectionNum"
	class="hmf-mb-l hmf-mb-m-xxl">
	​<mat-accordion>
		<mat-expansion-panel *ngFor="let datum of accordionData; let i = index">
			<mat-expansion-panel-header class="hmf-pl-0 accordion-focus">
				<mat-panel-title class="align-items-center">
					<span class="rectangle-flag hmf-px-xxxs hmf-py-m hmf-mr-m"></span>
					<h6 class="text text--accordion">{{ datum.question }}</h6>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<ng-container *ngIf="datum.answer">
				<div
					class="text text--accordion__text hmf-py-s"
					[innerHTML]="datum.answer | dcsgSanitizeHtml"
					commonAutoATags></div>
			</ng-container>
			<ng-container *ngIf="datum.accordionSection && datum.hasAccordionSection">
				<mat-expansion-panel *ngFor="let section of datum.accordionSection; let i = index">
					<mat-expansion-panel-header class="hmf-pl-0 accordion-focus-nested">
						<mat-panel-title class="align-items-center">
							<span
								class="rectangle-flag-nested hmf-px-xxxs hmf-py-m hmf-mr-m"></span>
							<h6 class="text text--accordion">{{ section.question }}</h6>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div
						class="text text--accordion__text hmf-py-s"
						[innerHTML]="section.answer | dcsgSanitizeHtml"
						commonAutoATags></div>
				</mat-expansion-panel>
			</ng-container>
		</mat-expansion-panel>
	</mat-accordion>
	<ng-container *ngFor="let datum of accordionData; let i = index">
		<div
			*ngIf="datum.cta"
			class="text ctas d-flex flex-column justify-content-center flex-md-row flex-md-wrap hmf-mt-s">
			<div
				*ngFor="let cta of datum.cta; let j = index"
				class="text-center d-flex justify-content-center flex-wrap hmf-px-xxs hmf-my-xxs">
				<a
					homefield-button
					height="base"
					variant="secondary"
					[href]="cta.link"
					[attr.altText]="cta.linkTitle"
					[dataEm]="createTag(i + 1, j + 1, cta.linkTitle, cta.linkTitle)"
					[attr.target]="targetService(cta.link)"
					[attr.aria-label]="cta.linkTitle">
					{{ cta.linkTitle }}
				</a>
			</div>
			{{ data.cta }}
		</div>
	</ng-container>
</section>
